<template>
  <div>
    <a-menu v-model:openKeys="state.openKeys" v-model:selectedKeys="state.selectedKeys" mode="inline" theme="dark"
      :items="items" @select="wayselectmenu"></a-menu>
  </div>
</template>
<script setup>
import { reactive, watch, h } from 'vue';
import {
  PieChartOutlined,
  DesktopOutlined,
  BarChartOutlined,
  FormOutlined,
  ControlOutlined,
  FileProtectOutlined,
  VerifiedOutlined
} from '@ant-design/icons-vue';

// 获取路由
import { useRoute, useRouter } from 'vue-router';
const route = useRoute();
const router = useRouter();
const state = reactive({
  selectedKeys: ['dataOverview'],
  openKeys: ['dataOverview']
});
const items = reactive([
  {
    key: 'dataOverview',
    icon: () => h(PieChartOutlined),
    label: '数据概览',
    title: '数据概览'
  },
  {
    key: 'list',
    icon: () => h(DesktopOutlined),
    label: '付费详情',
    title: '付费详情',
  },
  {
    key: 'payUserList',
    icon: () => h(BarChartOutlined),
    label: '付费用户',
    title: '付费用户',
  },
  // {
  //   key: 'collectionList',
  //   icon: () => h(FormOutlined),
  //   label: '收款码管理',
  //   title: '收款码管理',
  // },
  // {
  //   key: 'fleetCarList',
  //   icon: () => h(ControlOutlined),
  //   label: '车队管理',
  //   title: '车队管理',
  // },
  // {
  //   key: 'orderList',
  //   icon: () => h(FileProtectOutlined),
  //   label: '订单管理',
  //   title: '订单管理',
  // },
  // {
  //   key: 'voucherList',
  //   icon: () => h(VerifiedOutlined),
  //   label: '凭证管理',
  //   title: '凭证管理',
  // },
])
// watch(
//   () => state.openKeys,
//   (_val, oldVal) => {
//     state.preOpenKeys = oldVal;
//   },
// );
// 选择
const wayselectmenu = ({ key }) => {
  if (key === route.name) return;
  state.selectedKeys[0] = key;
  router.push({
    name: key
  })
}

  watch(
    () => route.fullPath,
    () => {
      state.selectedKeys[0] = route.name;
      state.openKeys = route.matched.slice(1).map((n) => n.name)
    },
    {
      immediate: true,
    },
  );

</script>